// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RomanticAudioBook_container__x4HW9 {
  max-width: 95%;
  margin: 0 auto;
  padding: 0rem;
  background-color: transparent;
  color: #fff;
}

.RomanticAudioBook_headerPart__H7D4s {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.RomanticAudioBook_heading__ju184 {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}

.RomanticAudioBook_view_all__4kok8 {
  color: #ff3b3b;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s ease;
  font-size: 1rem;
}

.RomanticAudioBook_view_all__4kok8:hover {
  color: #ff6b6b;
  text-decoration: underline;
}

.RomanticAudioBook_loading__ljtRY {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  color: #ff3b3b;
  font-size: 1.2rem;
}

.RomanticAudioBook_audiobook_swiper__6ClLh {
  width: 100%;
  padding: 0px; /* Add padding for pagination bullets */
}

.RomanticAudioBook_swiper_slide__Rogt6 {
  height: auto;
}

/* Swiper navigation buttons */
.RomanticAudioBook_audiobook_swiper__6ClLh .swiper-button-prev,
.RomanticAudioBook_audiobook_swiper__6ClLh .swiper-button-next {
  color: #ff3b3b;
  width: 30px;
  height: 30px;
}

.RomanticAudioBook_audiobook_swiper__6ClLh .swiper-button-prev:after,
.RomanticAudioBook_audiobook_swiper__6ClLh .swiper-button-next:after {
  font-size: 18px;
}

.RomanticAudioBook_audiobook_swiper__6ClLh .swiper-button-prev:hover,
.RomanticAudioBook_audiobook_swiper__6ClLh .swiper-button-next:hover {
  color: #ff6b6b;
}

/* Swiper pagination */
.RomanticAudioBook_audiobook_swiper__6ClLh .swiper-pagination-bullet {
  background: #555;
  opacity: 0.5;
}

.RomanticAudioBook_audiobook_swiper__6ClLh .swiper-pagination-bullet-active {
  background: #ff3b3b;
  opacity: 1;
}

.RomanticAudioBook_audiobook_item__z\\+DBJ {
  display: flex;
  flex-direction: column;
  background-color: #111;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
  cursor: pointer;
}

.RomanticAudioBook_audiobook_item__z\\+DBJ:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(255, 59, 59, 0.2);
}

.RomanticAudioBook_audiobook_image__qyiwr {
  width: 100%;
  object-fit: cover;
  border-bottom: 2px solid #ff3b3b;
  min-height: 225px;
}

.RomanticAudioBook_audiobook_content__tB20N {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.RomanticAudioBook_audiobook_header__bfgKN {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
}

.RomanticAudioBook_audiobook_title__W86-B {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin: 0;
  line-height: 1.3;
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.RomanticAudioBook_audiobook_time__-ZKYO {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: #ff3b3b;
  font-size: 0.9rem;
  margin: 0;
  white-space: nowrap;
}

.RomanticAudioBook_audiobook_description__j-jog {
  font-size: 0.9rem;
  color: #aaa;
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.4;
}

/* Responsive styles */
@media (max-width: 991px) {
  .RomanticAudioBook_container__x4HW9 {
  }
  
  .RomanticAudioBook_heading__ju184 {
    font-size: 18px;
  }
}

@media (max-width: 767px) {
  .RomanticAudioBook_container__x4HW9 {
  }
  
  .RomanticAudioBook_heading__ju184 {
    font-size: 18px;
  }
  
  .RomanticAudioBook_audiobook_title__W86-B {
    font-size: 0.9rem;
  }
  
  .RomanticAudioBook_audiobook_description__j-jog {
    font-size: 0.8rem;
    -webkit-line-clamp: 2;
  }
  
  .RomanticAudioBook_audiobook_content__tB20N {
    padding: 0.8rem;
  }
  
  .RomanticAudioBook_audiobook_time__-ZKYO {
    font-size: 0.8rem;
  }
  
  .RomanticAudioBook_view_all__4kok8 {
    font-size: 0.9rem;
    margin-top: 0;
  }
  .RomanticAudioBook_audiobook_image__qyiwr{
    min-height: 200px;
  }
  
  /* Smaller navigation arrows on mobile */
  .RomanticAudioBook_audiobook_swiper__6ClLh .swiper-button-prev,
  .RomanticAudioBook_audiobook_swiper__6ClLh .swiper-button-next {
    width: 24px;
    height: 24px;
  }
  
  .RomanticAudioBook_audiobook_swiper__6ClLh .swiper-button-prev:after,
  .RomanticAudioBook_audiobook_swiper__6ClLh .swiper-button-next:after {
    font-size: 14px;
  }
}

@media (max-width: 639px) {
  /* For very small screens adjust the swiper view */
  .RomanticAudioBook_audiobook_image__qyiwr {
    aspect-ratio: auto;
    min-height: 150px; /* Slightly taller images on very small screens */
  }

}

@media (max-width: 479px) {
  .RomanticAudioBook_headerPart__H7D4s {
    align-items: flex-start;
    gap: 0.5rem;
  }
  .RomanticAudioBook_audiobook_image__qyiwr{
    min-height: 130px; /* Slightly taller images on very small screens */
  }
  
  .RomanticAudioBook_heading__ju184 {
    font-size: 18px;
  }
  
  .RomanticAudioBook_audiobook_content__tB20N {
    padding: 0.2rem;
  }
  
  .RomanticAudioBook_audiobook_time__-ZKYO {
    font-size: 12px;
  }
  
  .RomanticAudioBook_audiobook_description__j-jog {
    font-size: 8px;
    -webkit-line-clamp: 2;
  }
  .RomanticAudioBook_audiobook_title__W86-B{
    font-size: 12px;
  }

}`, "",{"version":3,"sources":["webpack://./src/Homepage/components/Css/RomanticAudioBook.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,uCAAuC;AACvD;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;AAC9B;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;EACA;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;EACA;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;;EAEA,wCAAwC;EACxC;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,kDAAkD;EAClD;IACE,kBAAkB;IAClB,iBAAiB,EAAE,iDAAiD;EACtE;;AAEF;;AAEA;EACE;IACE,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,iBAAiB,EAAE,iDAAiD;EACtE;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;;AAEF","sourcesContent":[".container {\n  max-width: 95%;\n  margin: 0 auto;\n  padding: 0rem;\n  background-color: transparent;\n  color: #fff;\n}\n\n.headerPart {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.heading {\n  font-size: 20px;\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n}\n\n.view_all {\n  color: #ff3b3b;\n  font-weight: 500;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  font-size: 1rem;\n}\n\n.view_all:hover {\n  color: #ff6b6b;\n  text-decoration: underline;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  color: #ff3b3b;\n  font-size: 1.2rem;\n}\n\n.audiobook_swiper {\n  width: 100%;\n  padding: 0px; /* Add padding for pagination bullets */\n}\n\n.swiper_slide {\n  height: auto;\n}\n\n/* Swiper navigation buttons */\n.audiobook_swiper :global(.swiper-button-prev),\n.audiobook_swiper :global(.swiper-button-next) {\n  color: #ff3b3b;\n  width: 30px;\n  height: 30px;\n}\n\n.audiobook_swiper :global(.swiper-button-prev:after),\n.audiobook_swiper :global(.swiper-button-next:after) {\n  font-size: 18px;\n}\n\n.audiobook_swiper :global(.swiper-button-prev:hover),\n.audiobook_swiper :global(.swiper-button-next:hover) {\n  color: #ff6b6b;\n}\n\n/* Swiper pagination */\n.audiobook_swiper :global(.swiper-pagination-bullet) {\n  background: #555;\n  opacity: 0.5;\n}\n\n.audiobook_swiper :global(.swiper-pagination-bullet-active) {\n  background: #ff3b3b;\n  opacity: 1;\n}\n\n.audiobook_item {\n  display: flex;\n  flex-direction: column;\n  background-color: #111;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  height: 100%;\n  cursor: pointer;\n}\n\n.audiobook_item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 20px rgba(255, 59, 59, 0.2);\n}\n\n.audiobook_image {\n  width: 100%;\n  object-fit: cover;\n  border-bottom: 2px solid #ff3b3b;\n  min-height: 225px;\n}\n\n.audiobook_content {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.audiobook_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.5rem;\n}\n\n.audiobook_title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n  line-height: 1.3;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.audiobook_time {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: #ff3b3b;\n  font-size: 0.9rem;\n  margin: 0;\n  white-space: nowrap;\n}\n\n.audiobook_description {\n  font-size: 0.9rem;\n  color: #aaa;\n  margin: 0;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  line-height: 1.4;\n}\n\n/* Responsive styles */\n@media (max-width: 991px) {\n  .container {\n  }\n  \n  .heading {\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 767px) {\n  .container {\n  }\n  \n  .heading {\n    font-size: 18px;\n  }\n  \n  .audiobook_title {\n    font-size: 0.9rem;\n  }\n  \n  .audiobook_description {\n    font-size: 0.8rem;\n    -webkit-line-clamp: 2;\n  }\n  \n  .audiobook_content {\n    padding: 0.8rem;\n  }\n  \n  .audiobook_time {\n    font-size: 0.8rem;\n  }\n  \n  .view_all {\n    font-size: 0.9rem;\n    margin-top: 0;\n  }\n  .audiobook_image{\n    min-height: 200px;\n  }\n  \n  /* Smaller navigation arrows on mobile */\n  .audiobook_swiper :global(.swiper-button-prev),\n  .audiobook_swiper :global(.swiper-button-next) {\n    width: 24px;\n    height: 24px;\n  }\n  \n  .audiobook_swiper :global(.swiper-button-prev:after),\n  .audiobook_swiper :global(.swiper-button-next:after) {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 639px) {\n  /* For very small screens adjust the swiper view */\n  .audiobook_image {\n    aspect-ratio: auto;\n    min-height: 150px; /* Slightly taller images on very small screens */\n  }\n\n}\n\n@media (max-width: 479px) {\n  .headerPart {\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  .audiobook_image{\n    min-height: 130px; /* Slightly taller images on very small screens */\n  }\n  \n  .heading {\n    font-size: 18px;\n  }\n  \n  .audiobook_content {\n    padding: 0.2rem;\n  }\n  \n  .audiobook_time {\n    font-size: 12px;\n  }\n  \n  .audiobook_description {\n    font-size: 8px;\n    -webkit-line-clamp: 2;\n  }\n  .audiobook_title{\n    font-size: 12px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RomanticAudioBook_container__x4HW9`,
	"headerPart": `RomanticAudioBook_headerPart__H7D4s`,
	"heading": `RomanticAudioBook_heading__ju184`,
	"view_all": `RomanticAudioBook_view_all__4kok8`,
	"loading": `RomanticAudioBook_loading__ljtRY`,
	"audiobook_swiper": `RomanticAudioBook_audiobook_swiper__6ClLh`,
	"swiper_slide": `RomanticAudioBook_swiper_slide__Rogt6`,
	"audiobook_item": `RomanticAudioBook_audiobook_item__z+DBJ`,
	"audiobook_image": `RomanticAudioBook_audiobook_image__qyiwr`,
	"audiobook_content": `RomanticAudioBook_audiobook_content__tB20N`,
	"audiobook_header": `RomanticAudioBook_audiobook_header__bfgKN`,
	"audiobook_title": `RomanticAudioBook_audiobook_title__W86-B`,
	"audiobook_time": `RomanticAudioBook_audiobook_time__-ZKYO`,
	"audiobook_description": `RomanticAudioBook_audiobook_description__j-jog`
};
export default ___CSS_LOADER_EXPORT___;
